<template>
  <div class="modal proposal-preview-modal animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/preview') > -1 }">
    <div class="modal-background"></div>

    <comments-float :proposal="payload"></comments-float>

    <span class="close-modal">
      <i class="icon icon-close" @click="goBack()"></i>
    </span>

    <div class="modal-card animated fadeInUp">

      <div v-if="payload.status !== 'draft'" class="sent-notice">
        {{ $t('proposals.already_sent') }} <router-link :to="'/a/document/' + payload.id">{{ $t('proposals.click_here') }}</router-link>
      </div>

      <loading-indicator v-if="documentLoaded === false"></loading-indicator>

      <document-part-cover :payload="payload" v-if="documentLoaded" state="preview"></document-part-cover>

      <div class="document" v-if="documentLoaded" :style="{ 'font-family': payload.options.documentFont }">
        <div v-for="(part, key) in payload.body" :key="part.id">
          <div class="columns">
            <div class="column is-10 is-offset-1">
              <div class="part-wrapper">
                <document-part-h1 v-if="part.type === 'h1'" :part="part" state="preview"></document-part-h1>
                <document-part-h2 v-if="part.type === 'h2'" :part="part" state="preview"></document-part-h2>
                <document-part-h3 v-if="part.type === 'h3'" :part="part" state="preview"></document-part-h3>
                <document-part-text v-if="part.type === 'text'" :part="part" state="preview"></document-part-text>
                <document-part-bulleted-list v-if="part.type === 'bulleted-list'" :part="part" state="preview"></document-part-bulleted-list>
                <document-part-numbered-list v-if="part.type === 'numbered-list'" :part="part" state="preview"></document-part-numbered-list>
                <document-part-image v-if="part.type === 'image'" :part="part" state="preview"></document-part-image>
                <document-part-table v-if="part.type === 'table'" :part="part" state="preview"></document-part-table>
                <document-part-module v-if="part.type === 'module'" :part="part" state="preview"></document-part-module>
                <document-part-pricing-table v-if="part.type === 'pricing-table'" :part="part" state="preview"></document-part-pricing-table>
                <document-part-page-break v-if="part.type === 'page-break'" state="preview"></document-part-page-break>
                <document-part-initials v-if="part.type === 'initials'" :signatures="signatures" :part="part" state="preview"></document-part-initials>
                <document-part-signatures v-if="part.type === 'signatures'" :signatures="payload.signatures" :part="part" state="preview"></document-part-signatures>
              </div>
            </div>
          </div>
        </div>

        <router-link :to="'/a/document-link/' + mySigningUrl" v-if="iCanSign" class="sign-now">{{ $t('proposals.sign_now') }}</router-link>

      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import CommentsFloat from 'components/partials/comments-float.vue';
  import DocumentPartCover from '../document-parts/cover.vue';
  import DocumentPartText from '../document-parts/text.vue';
  import DocumentPartH1 from '../document-parts/h1.vue';
  import DocumentPartH2 from '../document-parts/h2.vue';
  import DocumentPartH3 from '../document-parts/h3.vue';
  import DocumentPartBulletedList from '../document-parts/bulleted-list.vue';
  import DocumentPartNumberedList from '../document-parts/numbered-list.vue';
  import DocumentPartImage from '../document-parts/image.vue';
  import DocumentPartTable from '../document-parts/table.vue';
  import DocumentPartPageBreak from '../document-parts/page-break.vue';
  import DocumentPartPricingTable from '../document-parts/pricing-table.vue';
  import DocumentPartSignatures from '../document-parts/signatures.vue';

  export default {
    mixins: [API],
    components: {
      CommentsFloat,
      DocumentPartCover,
      DocumentPartText,
      DocumentPartH1,
      DocumentPartH2,
      DocumentPartH3,
      DocumentPartBulletedList,
      DocumentPartNumberedList,
      DocumentPartImage,
      DocumentPartTable,
      DocumentPartPageBreak,
      DocumentPartPricingTable,
      DocumentPartSignatures,
    },
    mounted() {
      this.api().fetchDocument(this.$route.params.id).then(payload => {
        this.payload = payload;
        this.documentLoaded = true;
      });
    },
    destroyed() {
      // hotkeys.unbind('esc');
    },
    data() {
      return {
        payload: {},
        documentLoaded: false
      }
    },
    methods: {
      goBack() {
        window.history.back();
      }
    },
    computed: {
      iCanSign() {
        let isTheSignatory = false;
        const isNotDraft = this.payload.status !== 'draft';

        const signatures = _.find(this.payload.body, section => {
          return section.type === 'signatures';
        });

        signatures.content.forEach(s => {
          if (s.signatory.type === 'user' && s.signatory.id === window.Spark.state.user.id) {
            isTheSignatory = true;
          }
        });

        return isNotDraft && isTheSignatory;
      },
      mySigningUrl() {
        let uuid = false;
        if (this.payload.links) {
          uuid = this.payload.links.find(link => {
            return link.recipient_type === "App\\User" && link.recipient_id === window.Spark.state.user.id;
          });
        }
        return uuid.uuid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .sent-notice {
    position: absolute;
    top: 13px;
    left: 0;
    width: 100%;
    background-color: $yellow;
    color: $white;
    padding: 10px 5px;
    border-radius: 3px;
    text-align: center;
    z-index: 1;

    a {
      color: $white;
      text-decoration: underline;
    }
  }

  .sign-now {
    position: fixed;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
    background-color: $green;
    color: $white;
    text-transform: uppercase;
    padding: 10px 75px;
    border-radius: 3px;
    text-align: center;
    z-index: 1;
    box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
  }

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .document {
    min-height: 1056px;
    * {
      font-family: inherit;
    }
  }

  .close-modal {
    i {
      font-size: 30px;
      right: 30px;
      top: 15px;
      position: fixed;
      &:hover {
       color: $green;
       cursor: pointer;
      }
    }
  }

  .modal {
    .modal-card {
      align-self: flex-start;
      overflow-y: auto;
      box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
      .modal-card-head,
      .modal-card-foot {
        border-color: $white;
        background: $white;
      }
      .modal-card-head {
        padding: 40px;
        .modal-card-title {
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .modal-card-body {
        padding: 0 40px;
      }
      .modal-card-foot {
        text-align: center;
        display: block;
        padding: 8px 40px 40px;
      }
    }
    .delete {
      top: 20px;
      right: 20px;
      position: fixed;
    }
    &.is-active {
      overflow: scroll;
      display: flex;
    }
  }

  .proposal-preview-modal {
    .modal-card {
      background: none;
      margin-top: 0;
      width: 800px;
      margin-left: auto;
      margin-right: auto;
      overflow: visible;
      box-shadow: none;
    }
  }
</style>



// WEBPACK FOOTER //
// document-preview-modal.vue?f1d6acec